import { Card, CardContent, CardFooter, CardHeader } from "@repo/ui";
import { Badge, Button } from "@repo/ui";

type Project = {
  title: string;
  description: string;
  image: string;
  tags: string[];
  link?: string;
  repo?: string;
};

export default function ProjectCard({ project }: { project: Project }) {
  return (
    <Card className="overflow-hidden border-none bg-card shadow-none ring-1 ring-border">
      <div className="aspect-[16/10] w-full overflow-hidden">
        <img src={project.image} alt={project.title} className="h-full w-full object-cover" />
      </div>
      <CardHeader>
        <h3 className="text-xl font-semibold tracking-tight">{project.title}</h3>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground">{project.description}</p>
        <div className="mt-4 flex flex-wrap gap-2">
          {project.tags.map((t) => (
            <Badge key={t} variant="secondary">
              {t}
            </Badge>
          ))}
        </div>
      </CardContent>
      <CardFooter className="flex gap-3">
        {project.link && (
          <a href={project.link} target="_blank" rel="noreferrer">
            <Button size="sm">Live</Button>
          </a>
        )}
        {project.repo && (
          <a href={project.repo} target="_blank" rel="noreferrer">
            <Button variant="outline" size="sm">
              Code
            </Button>
          </a>
        )}
      </CardFooter>
    </Card>
  );
}
